import { onScopeDispose, watch } from 'vue'
import { useQueryClient } from '@tanstack/vue-query'
import { personalSession } from '@/queries/personal-session'
import { gameService } from '@/services/game/game.service'

export function useGameSessionBindings(): void {
  const queryClient = useQueryClient()
  watch(
    personalSession,
    (session, previous) => {
      gameService.setSession(session)
      if (previous) {
        for (const prefix of [
          ['auth', 'user'],
          ['stats', 'user'],
          ['roulette', 'history'],
        ]) {
          const queryKey = [...prefix, previous.id]
          void queryClient.cancelQueries({ queryKey })
          queryClient.removeQueries({ queryKey })
        }
      }
    },
    { immediate: true, flush: 'sync' }
  )
  onScopeDispose(() => {
    gameService.setSession(null)
  })
}
